import { Div, Ref, Button, Text, Link, PasswordInput, Span } from "@tblabs/truffle";
import { AuthService } from "./AuthService";
import { Box } from "../../Components/Utils/Box";


export class AdminLoginPage extends Div
{
    private password = new Ref<string>("").Storable("admin-password");
    private loginButton = new Button("Zaloguj");
    private loginStatus = new Ref<string>("");
    private statusBox = new Text(this.loginStatus)
        .DisplayBlock().Background("orange").FloatLeft().Padding(9, 32).MarginTop(8).Color("#fff")
        .Hide()

    constructor(private _auth: AuthService)
    {
        super();
        this.Margin(32)
    }

    protected async OnAppend(): Promise<void>
    {
        if (this._auth.IsAuthorized)
        {
            this.Append(
                this._auth.IsAuthorized
                    ? `Jesteś zalogowany jako ${this._auth.UserInfo?.User?.Name || "(brak nazwy użytkownika)"}`
                    : `Nie jesteś zalogowany`,

                new Button("Wyloguj").MarginLeft(32)
                    .OnClick(() =>
                    {
                        this._auth.Logout();
                        window.location.hash = "admin/login";
                        window.location.reload();
                    })
            )

            return;
        }

        const passwordInput = new PasswordInput(this.password)
            .OnEnterKeyPressed(async () => await this.TryLogin())
            .OnKeyDown(() => this.statusBox.Hide())
            .Attribute("data-testid", "login-password-input");

        this.loginButton
            .Class("uk-button-primary").MarginTop(8).FloatRight()
            .OnClick(async () => await this.TryLogin())
            .EnableWhen(this.password, v => (v as string).length > 0)
            .Attribute("data-testid", "login-button");

        this.Append(
            new Box(
                new Span("Hasło").DisplayBlock().TextAlignLeft(),
                passwordInput,
                this.loginButton,
                this.statusBox)
        )
    }

    private async TryLogin(): Promise<void>
    {
        if (this.password.value == "")
        {
            this.ShowStatus("No password provided");
            return;
        }

        const pass = this.password.value.trim();

        this.loginButton.Label("Trying to login...");

        const loginTimeoutTimer = setTimeout(() =>
        {
            this.ShowStatus("Authorization timeout. Try again later");
            this.loginButton.Label("Try login again");
        }, 15000);

        const isLoggedIn = await this._auth.TryLogin(pass);

        clearTimeout(loginTimeoutTimer);

        if (isLoggedIn)
        {
            // window.location.hash = "admin/orders";
            this.Clear().Append(
                new Span("Zalogowano jako " + this._auth.UserInfo?.User?.Name).DisplayBlock().TextAlignLeft(),
                new Button("Przejdź do zamówień").OnClick(() =>
                {
                    window.location.hash = "admin/orders";
                    window.location.reload();
                }).MarginTop(32),
            );
        }
        else
        {
            this.ShowStatus("Problem z logowaniem");
            this.loginButton.Label("Spróbuj ponownie");
        }
    }

    private ShowStatus(status: string): void
    {
        this.statusBox.Show();
        this.loginStatus.value = status;
    }
}

// TODO: AgentLoginPage jest bardzo podobne do AdminLoginPage, można to uwspólnić
export class AgentLoginPage extends Div
{
    private password = new Ref<string>("").Storable("admin-password");
    private loginButton = new Button("Zaloguj");
    private loginStatus = new Ref<string>("");
    private statusBox = new Text(this.loginStatus)
        .DisplayBlock().Background("orange").FloatLeft().Padding(9, 32).MarginTop(8).Color("#fff")
        .Hide()

    constructor(private _auth: AuthService)
    {
        super();
        this.Margin(32)
    }

    protected async OnAppend(): Promise<void>
    {
        if (this._auth.IsAuthorized)
        {
            this.Append(
                this._auth.IsAuthorized
                    ? `Jesteś zalogowany jako ${this._auth.UserInfo?.User?.Name || "(brak nazwy użytkownika)"}`
                    : `Nie jesteś zalogowany`,

                new Button("Wyloguj").MarginLeft(32)
                    .OnClick(() =>
                    {
                        this._auth.Logout();
                        window.location.hash = "agent/login";
                    })
            )

            return;
        }

        const passwordInput = new PasswordInput(this.password)
            .OnEnterKeyPressed(async () => await this.TryLogin())
            .OnKeyDown(() => this.statusBox.Hide())
            .Attribute("data-testid", "login-password-input");

        this.loginButton
            .Class("uk-button-primary").MarginTop(8).FloatRight()
            .OnClick(async () => await this.TryLogin())
            .EnableWhen(this.password, v => (v as string).length > 0)
            .Attribute("data-testid", "login-button");

        this.Append(
            new Box(
                new Span("Hasło").DisplayBlock().TextAlignLeft(),
                passwordInput,
                this.loginButton,
                this.statusBox)
        )
    }

    private async TryLogin(): Promise<void>
    {
        if (this.password.value == "")
        {
            this.ShowStatus("No password provided");
            return;
        }

        const pass = this.password.value.trim();

        this.loginButton.Label("Trying to login...");

        const loginTimeoutTimer = setTimeout(() =>
        {
            this.ShowStatus("Authorization timeout. Try again later");
            this.loginButton.Label("Try login again");
        }, 15000);

        const isLoggedIn = await this._auth.TryLogin(pass);

        clearTimeout(loginTimeoutTimer);

        if (isLoggedIn)
        {
            this.Clear().Append(
                new Span("Zalogowano jako " + this._auth.UserInfo?.User?.Name).DisplayBlock().TextAlignLeft(),
                new Button("Przejdź do zadań").OnClick(() => window.location.hash = "agent/" + this._auth.UserInfo?.User?.Id + "/tasks").MarginTop(32),
            );
        }
        else
        {
            this.ShowStatus("Problem z logowaniem");
            this.loginButton.Label("Spróbuj ponownie");
        }
    }

    private ShowStatus(status: string): void
    {
        this.statusBox.Show();
        this.loginStatus.value = status;
    }
}
